/**
 * Centred spinner — used as a route-level loading placeholder.
 *
 * For inline / skeleton states, prefer the `aim-shimmer` skeleton
 * blocks in `MessageStream.tsx` and `Dashboard.tsx`. This component is
 * for "we have nothing to show yet" full-screen waits only.
 */
export function LoadingScreen({
  message = "Loading…",
}: {
  message?: string;
}): React.ReactElement {
  return (
    <div
      className="min-h-full flex flex-col items-center justify-center gap-3 px-6 text-center"
      role="status"
      aria-live="polite"
    >
      <div className="loader" aria-hidden="true" />
      <p className="text-sm" style={{ color: "var(--color-hint)" }}>
        {message}
      </p>
    </div>
  );
}
